/**
 * @Description 五维/六维雷达图
 */
import React from 'react';
import { FC } from 'react';
import SiteMapRadarChart from './SiteMapRadarChart';
import styles from './index.module.less';
import { isEqual } from '@lhb/func';
const FiveDimensional:FC<any> = React.memo(({
  indicator,
  seriesDataValue,
  height,
  radarRadius,
  animation = true,
  resizable = true,
  valueFontSize,
  backgroundColor = '#F6F7F9',
}) => {
  // 格式估下
  // const seriesDataValue = [90, 90, 90, 89, 88];
  // const indicator = [
  //   { name: '人口客群', max: 100, value: seriesDataValue[0] },
  //   { name: '消费能力', max: 100, value: seriesDataValue[1] },
  //   { name: '销售潜力', max: 100, value: seriesDataValue[2] },
  //   { name: '业态氛围', max: 100, value: seriesDataValue[3] },
  //   { name: '区域特性', max: 100, value: seriesDataValue[4] },
  // ];
  return <SiteMapRadarChart
    wrapperClassName={styles.siteMapRadarChart}
    height={height}
    radarRadius={radarRadius}
    shape='circle'
    indicator={indicator}

    seriesData={[{
      value: seriesDataValue,
      // value: [90, 90, 90, 89, 88],
      unit: '分'
    }]}
    resizable={resizable}
    config={{
      backgroundColor,
      animation,
    }}
    valueFontSize={valueFontSize}
  />;
}, (oldProps, newProps) => {
  const flag = isEqual(oldProps, newProps);
  return flag;
});
export default FiveDimensional;
